import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LogOut } from "lucide-react";

export default function EmergencyLogout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-md3-surface p-4">
      <Card className="max-w-md w-full shadow-md3-1 hover:shadow-md3-2 transition-shadow duration-200 ">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <LogOut className="w-8 h-8 text-blue-600" />
            </div>
          </div>
          <CardTitle className="text-2xl text-md3-title-medium text-md3-on-surface">Logout</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-center text-md3-on-surface-variant">
            Click the button below to logout from the system.
          </p>
          
          <Button
            onClick={handleLogout}
            className="w-full"
            size="lg"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout Now
          </Button>

          <div className="text-center">
            <p className="text-xs text-md3-on-surface-variant">
              Having trouble? This will clear your session and redirect to login.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
